import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UserSettingsService from "src/services/userSettingsService";
import { useSelector } from "src/store";
import { CustomBadge } from "src/ui/shared/CustomBadge";
import { SecondaryButton } from "src/ui/shared/CustomButton";

import { selectGroups } from "@dashboard/groups/store/selectors";

import { GroupFilterModal } from "../../shared/components/GroupFilterModal";

const setOverviewPageGroupFilter = (filters: number[]) => {
    UserSettingsService.setWorkspaceValue("overviewPage.groupFilter", filters);
};

type FormValues = {
    [key: string]: boolean;
};

type Props = {
    filter: number[];
    setFilter: (filter: number[]) => void;
};

export const Filter = ({ filter, setFilter }: Props) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation(["pages", "modals"]);
    const groups = useSelector(selectGroups);
    const initialValues = groups.reduce((acc, group) => ({ ...acc, [`$${group.id}`]: filter.includes(group.id) }), {});

    const onSubmit = (values: FormValues) => {
        const groupIds = Object.keys(values)
            .filter((key) => values[key])
            .map((key) => parseInt(key));

        setFilter(groupIds);
        setOverviewPageGroupFilter(groupIds);
    };

    return (
        <React.Fragment>
            <CustomBadge badgeContent={filter.length}>
                <SecondaryButton startIcon={<i className="fa-solid fa-filter" />} onClick={() => setOpen(true)}>
                    {t("pages:overviewPage.filter")}
                </SecondaryButton>
            </CustomBadge>

            <GroupFilterModal
                open={open}
                initialValues={initialValues}
                setOpen={setOpen}
                onSubmit={onSubmit}
                description={t("modals:groupFilter.overviewDescription")}
            />
        </React.Fragment>
    );
};
